// @ts-nocheck
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';
import { getTheme } from 'settings/theme';

const { boxShadow, palette } = getTheme();

const getScroll = (props: Record<string, any>): string => {
  const listContainer = props.children.props.children[1];
  const elements = listContainer ? listContainer.props.children[1].props.children.length : 0;
  return elements > 5 ? 'scroll' : '';
};

const DropdownWrapper: StatelessFunctionalComponent<any> = styled.div`
  cursor: default;
  height: 4.2rem;
  flex: 1;

  .dropdown {
    &__container {
      position: relative;
    }

    &__header,
    &__header--open,
    &__header--invalid,
    &__header--open--invalid {
      align-items: center;
      border: 0.1rem solid ${palette.greyscale.pewter};
      border-radius: 0.4rem;
      display: flex;
      height: 4.2rem;
      justify-content: space-between;
      padding-left: 1.2rem;
      padding-right: 1.2rem;

      :hover {
        border: 0.2rem solid ${palette.greyscale.pewter};
        padding-left: 1.1rem;
        padding-right: 1.1rem;
      }

      .icon-arrow_up,
      .icon-arrow_down {
        color: ${palette.greyscale.smoke}
        font-size: 2.6rem
      }

      &--invalid,
      &--invalid:hover,
      &--open--invalid {
        border: 0.2rem solid ${palette.red.default};
        color: ${palette.red.default};
        padding-left: 1.1rem;
        padding-right: 1.1rem;

        .icon-arrow_up,
        .icon-arrow_down {
          color: ${palette.red.default};
        }
      }

      &--open,
      &--open--invalid {
        border: 0.1rem solid ${palette.greyscale.black};
        border-bottom: none;
        border-radius: 0.4rem 0.4rem 0 0;
        box-shadow: ${boxShadow.default};
        height: 3.7rem;
        padding-left: 1.2rem;
        padding-right: 1.2rem;
        padding-top: 0.4rem;

        :hover {
          border: 0.1rem solid ${palette.greyscale.black};
          border-bottom: none;
          padding-left: 1.2rem;
          padding-right: 1.2rem;
          padding-top: 0.4rem;
        }
      }
    }

    &__list {
      background-color: ${palette.greyscale.white};
      border: 0.1rem solid ${palette.greyscale.black};
      border-radius: 0 0 0.4rem 0.4rem;
      border-top: none;
      box-shadow: ${boxShadow.default};
      position: absolute;
      z-index: 10;
      width: 100%;

      &__item {
        align-items: center;
        display: flex;
        height: 3.6rem;
        margin-bottom: 0.6rem;
        margin-top: 0.6rem;
        padding-left: 1.2rem;

        &__icon {
          font-size: 1.6rem;
          margin-right: 1rem;
        }

        span {
          display: flex;
        }

        :hover {
          background-color: ${palette.greyscale.snow};
        }
      }

      hr {
        margin: 0;
        margin-left: 1.2rem;
        margin-right: 1.2rem;
      }
    }

    &__selected {
      background-color: ${palette.greyscale.snow};
    }

    &__touched {
      border-color: ${palette.greyscale.black};
    }
  }

  ul {
    list-style-type: none;
    margin-block-start: 0;
    margin-block-end: 0;
    max-height: 25rem;
    overflow-y: ${getScroll};
    padding-inline-start: 0;
  }

  .disabled {
    background-color: ${palette.greyscale.cloud};
  }
`;
export default DropdownWrapper;
